import { render, staticRenderFns } from "./ArticleFormView.vue?vue&type=template&id=34fdd688&scoped=true&"
import script from "./ArticleFormView.vue?vue&type=script&lang=js&"
export * from "./ArticleFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fdd688",
  null
  
)

export default component.exports